<div class="d-flex align-items-center position-relative">
    <fa-icon [icon]="faLock" class="qai-password-icon me-2" style="color: lightgrey"></fa-icon>
    <input [type]="showPassword ? 'text' : 'password'" [formControl]="control()" [id]="id()" [name]="id()"
        class="form-control qai-form-control qai-form-control_password" [placeholder]="placeholder()"
        [class.is-valid]="showValidatorCSS() && control().valid && (control().dirty || control().touched)" 
        [class.is-invalid]="showValidatorCSS() && control().invalid && (control().dirty || control().touched)" 
        />
    <button type="button" class="btn btn-link qai-password-toggle" (click)="showPassword = !showPassword" type="button">
        <fa-icon [icon]="showPassword ? faEyeSlash : faEye"></fa-icon>
    </button>
</div>